import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { EmployeesRolesListResponse } from '@modules/employees/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { EMPLOYEES_LIST_PERMISSIONS } from '@modules/employees/constants';
import {
  EMPLOYEES_ROLES_LIST_API_URL,
  EMPLOYEES_ROLES_LIST_QUERY_KEY,
} from '@modules/employees/submodules/create/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useEmployeeRolesListQuery(): IContextQueryResult<
  EmployeesRolesListResponse,
  Error
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<EmployeesRolesListResponse>({
    queryKey: [EMPLOYEES_ROLES_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<EmployeesRolesListResponse>(
      EMPLOYEES_ROLES_LIST_API_URL,
      {
        signal,
        permission: EMPLOYEES_LIST_PERMISSIONS.CREATE,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
